module.exports = __webpack_public_path__ + "img/login-background.5aaaab93.jpg";